import { months } from "../../Utils/months";
const validate = (values, props) => {
    const errors = {};
    const message = 'Campo requerido';
    const messageMax100 = 'No debe ser mayor a 100%';
    const messageNoNegatives = 'No debe ser negativo';
    const messageIvaNotEqualTo100 = 'La suma de IVA sujeto a retención y no retenido debe ser 100%';

    // Validaciones para el tab "PRODUCCION_FINCA"
    if (props.tab === 'PRODUCCION_FINCA') {
        if (!values.dollar_exchange) {
            errors.dollar_exchange = message;
        }
    }

    const requiredFieldAllowZero = (value) => {
        return value === null || value === undefined || value === '';
    }

    // Validación para campos mensuales en la tabla de Compras
    if (props.tab === 'COMPRAS') {
        // Verificar si purchase_price_table existe y tiene generic_row
        if (values.purchase_price_table && values.purchase_price_table.generic_row) {
            // Mapeo de los nombres de meses en inglés a los nombres en español usados en el objeto
            
            // Validar cada fila de la tabla
            values.purchase_price_table.generic_row.forEach((row, rowIndex) => {
                // Solo validar las filas que no están deshabilitadas (índices 0 y 2)
                if (rowIndex === 0 || rowIndex === 2) {
                    months.forEach(month => {

                        if (requiredFieldAllowZero(row[month])) {
                            errors.purchase_price_table = errors.purchase_price_table || {};
                            errors.purchase_price_table.generic_row = errors.purchase_price_table.generic_row || [];
                            errors.purchase_price_table.generic_row[rowIndex] = errors.purchase_price_table.generic_row[rowIndex] || {};
                            errors.purchase_price_table.generic_row[rowIndex][month] = message;
                        }
                    });
                }
            });
        }
    }

    if (props.tab === 'PRECIOS') {
        if (requiredFieldAllowZero(values.mar_obj_latex)) {
            errors.mar_obj_latex = message;
        }
        if (requiredFieldAllowZero(values.mar_obj_solido)) {
            errors.mar_obj_solido = message;
        }
        if (requiredFieldAllowZero(values.skim_price_percentage_on_solid)) {
            errors.skim_price_percentage_on_solid = message;
        }
    }
    
    if (props.tab === 'ISR') {
        // Validación de campo requerido
        if (requiredFieldAllowZero(values.tax_isr)) {
            errors.tax_isr = message;
        }
        
        // Validación para que no exceda de 100
        if (values.tax_isr && parseFloat(values.tax_isr) > 100) {
            errors.tax_isr = 'El valor no puede ser mayor a 100';
        }
    }

    if (props.tab === 'VARIABLES') {
        if (requiredFieldAllowZero(values.var_yield)) {
            errors.var_yield = message;
        }
        if (requiredFieldAllowZero(values.var_skim)) {
            errors.var_skim = message;
        }
        if (requiredFieldAllowZero(values.var_lost)) {
            errors.var_lost = message;
        }
        if (requiredFieldAllowZero(values.var_clot_wash)) {
            errors.var_clot_wash = message;
        }
        if (requiredFieldAllowZero(values.var_clot_traps)) {
            errors.var_clot_traps = message;
        }
        if (requiredFieldAllowZero(values.var_clot_centrifuged)) {
            errors.var_clot_centrifuged = message;
        }
        if (requiredFieldAllowZero(values.skim_ratio_for_solids)) {
            errors.skim_ratio_for_solids = message;
        }
        if (requiredFieldAllowZero(values.latex_makeup_price)) {
            errors.latex_makeup_price = message;
        }
        if (requiredFieldAllowZero(values.solid_makeup_price)) {
            errors.solid_makeup_price = message;
        }
    }

    if (props.tab === 'CREDITO_FISCAL') {
        const taxCredit = values.parameter_tax_credit || {};
        const taxRequiredFields = [
            'special_invoice', 'normal_invoice', 'does_not_generate_retencion', 'if_it_generates_retention',
            'iva_subject_to_withholding', 'iva_not_withheld', 'exported_decree_29_89', 'special_taxpayers',
            'export_op_retention', 'local_op_retention', 'special_regime'
        ];

        taxRequiredFields.forEach(field => {
            if (!taxCredit[field]) {
                errors.parameter_tax_credit = errors.parameter_tax_credit || {};
                errors.parameter_tax_credit[field] = message;
            }
        });

        const validatePercentageField = (fieldName, fieldValue) => {
            if (fieldValue < 0) {
                errors.parameter_tax_credit = errors.parameter_tax_credit || {};
                errors.parameter_tax_credit[fieldName] = messageNoNegatives;
            } else if (fieldValue > 100) {
                errors.parameter_tax_credit = errors.parameter_tax_credit || {};
                errors.parameter_tax_credit[fieldName] = messageMax100;
            }
        };

        taxRequiredFields.forEach(field => {
            if (taxCredit[field] !== undefined) {
                validatePercentageField(field, taxCredit[field]);
            }
        });

        const totalIva = (taxCredit.iva_subject_to_withholding || 0) + (taxCredit.iva_not_withheld || 0);
        if (totalIva !== 100) {
            errors.parameter_tax_credit = errors.parameter_tax_credit || {};
            errors.parameter_tax_credit.iva_subject_to_withholding = messageIvaNotEqualTo100;
            errors.parameter_tax_credit.iva_not_withheld = messageIvaNotEqualTo100;
        }
    }

    return errors;
};

export default validate;
